import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs';

import { SubscriptionsApi } from '../../api/subscriptions.api';
import { PaymentsApiActions } from './payments.actions';

@Injectable()
export class PaymentsEffects {
  constructor(private api: SubscriptionsApi, private actions$: Actions) {}

  loadPayments$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PaymentsApiActions.fetchPayments),
      switchMap((action) => {
        return this.api.getPayments$(action.subscriptionId);
      }),
      map((payments) => {
        return PaymentsApiActions.retrievedPayments({ payments });
      })
    );
  });

  loadPrepaidCards$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PaymentsApiActions.fetchPrepaidCards),
      switchMap((action) => {
        return this.api.getPrepaidCards$(action.subscriptionId);
      }),
      map((prepaidCards) => {
        return PaymentsApiActions.retrievedPrepaidCards({ prepaidCards });
      })
    );
  });
}
